import { kameURL } from '../endpoints';
import KameSdk from '@nackle/kame-sdk';

function KameService( { access_token } ) {
    const fetchWithAuth = function( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                'authorization': `Bearer ${ access_token }`
            }
        };

        return fetch( url, options );
    };

    const sdk = new KameSdk( kameURL, fetchWithAuth );

    const listPrograms = async () => {
        try {
            const res = await sdk.getPrograms();

            const formattedRes = res.programs.sort(
            ( a, b ) => a.name.localeCompare( b.name, undefined, { 'sensitivity': 'base' } )
            );
            
            return formattedRes;
        } catch ( error ) {
            throw new Error( 'kame listPrograms error: ', error );
        }
    };

    return {
        listPrograms
    };
}

export default KameService;


